// extracted by mini-css-extract-plugin
export default {"Tenant__profile":"SingleTenant_Tenant__profile__ZKmbv","Tenant__photo":"SingleTenant_Tenant__photo__sAcvV","Tenant__info":"SingleTenant_Tenant__info__j13Wk"};